import React, { useState } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight, FaImages } from "react-icons/fa";

const GallerySection = () => {
  const imageCount = 12;
  const imagePaths = Array.from(
    { length: imageCount },
    (_, i) => `/image${i + 1}.png`
  );

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = "auto";
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? imagePaths.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === imagePaths.length - 1 ? 0 : prev + 1));
  };
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxOpen]);

  return (
    <>
      <section className="w-full bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-md">
              <FaImages className="h-5 w-5 text-green-600" />
              <span className="text-sm font-semibold text-gray-700">Our Memories</span>
            </div>
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900 md:text-4xl">
              Photo <span className="text-green-600">Gallery</span>
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base text-gray-600 md:text-lg">
              Glimpses of workshops, events, and campus life at ITI Bhaupur.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {imagePaths.map((path, idx) => (
              <div
                key={idx}
                className="group relative overflow-hidden rounded-2xl shadow-md transition-all duration-300 hover:shadow-xl cursor-pointer"
                onClick={() => openLightbox(idx)}
              >
                <img
                  src={path}
                  alt={`Gallery ${idx + 1}`}
                  className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/400x300?text=Image+Not+Found";
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <div className="absolute bottom-0 left-0 right-0 p-3 text-center text-white translate-y-full transition-transform duration-300 group-hover:translate-y-0">
                  <span className="text-sm font-medium">Click to enlarge</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {lightboxOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 z-10 rounded-full bg-white/20 p-2 text-white transition hover:bg-white/30"
            onClick={closeLightbox}
            aria-label="Close"
          >
            <FaTimes className="h-6 w-6" />
          </button>

          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-2 text-white transition hover:bg-white/30"
            onClick={(e) => {
              e.stopPropagation();
              goPrev();
            }}
            aria-label="Previous"
          >
            <FaChevronLeft className="h-6 w-6" />
          </button>

          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-2 text-white transition hover:bg-white/30"
            onClick={(e) => {
              e.stopPropagation();
              goNext();
            }}
            aria-label="Next"
          >
            <FaChevronRight className="h-6 w-6" />
          </button>

          <div
            className="max-h-[90vh] max-w-[90vw] overflow-hidden rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={imagePaths[currentIndex]}
              alt={`Gallery ${currentIndex + 1}`}
              className="h-auto w-full object-contain"
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/800x600?text=Image+Not+Found";
              }}
            />
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 rounded-full bg-black/50 px-3 py-1 text-sm text-white">
              {currentIndex + 1} / {imagePaths.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GallerySection;